import { SVGProps } from "react";

interface ArrowSvgProps extends SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
  direction?: "right" | "left" | "up" | "down";
}

const ArrowIcon = ({
  size = 20,
  color = "black",
  direction = "right",
  ...props
}: ArrowSvgProps) => {
  let rotation = 0;
  switch (direction) {
    case "right":
      rotation = 0;
      break;
    case "down":
      rotation = 90;
      break;
    case "left":
      rotation = 180;
      break;
    case "up":
      rotation = -90;
      break;
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `rotate(${rotation}deg)` }}
      {...props}
    >
      <path
        d="M15.8337 9.9987H4.16699"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.667 14.1667L15.8337 10"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.667 5.83203L15.8337 9.9987"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowIcon;
